const state = () => ({
    breadcrumb: null,
    dashboardAnimationsExecuted: false
})

const actions = {
    SET_BREADCRUMB: ({ commit }, payload) => {
        commit("SET_BREADCRUMB", payload)
    },

    CLEAR_BREADCRUMB: ({ commit }) => {
        commit("SET_BREADCRUMB", null)
    },

    SET_STATE_DASHBOARD_ANIMATIONS_EXECUTED: ({ commit }, payload) => {
        commit("SET_STATE_DASHBOARD_ANIMATIONS_EXECUTED", payload)
    }
}

const mutations = {
    SET_BREADCRUMB: (state, payload) => {
        state.breadcrumb = payload
    },

    SET_STATE_DASHBOARD_ANIMATIONS_EXECUTED: (state, payload) => {
        state.dashboardAnimationsExecuted = payload
    }
}

const getters = {
    BREADCRUMB: state => {
        return state.breadcrumb
    },

    DASHBOARD_ANIMATIONS_EXECUTED: state => {
        return state.dashboardAnimationsExecuted
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}
